import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';
import BarRestaurantOrderCard from './BarRestaurantOrderCard';
import BarRestaurantOrderDetailModal from './BarRestaurantOrderDetailModal';
import './BarRestaurantListFullscreen.css';
import AppIcon from './icons/AppIcon';

export default function BarRestaurantListFullscreen({ 
  listId, 
  listName, 
  orders, 
  onClose, 
  projectId 
}) {
  const [localOrders, setLocalOrders] = useState(orders);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Real-time subscription para atualizações
  useEffect(() => {
    if (!projectId) return;

    console.log(`[BarRestaurantListFullscreen] Configurando Real-time para lista: ${listId}`);

    const ordersChannel = supabase
      .channel(`bar_restaurant_orders_fullscreen:${projectId}:${listId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'bar_restaurant_orders',
          filter: `project_id=eq.${projectId}`
        },
        (payload) => {
          console.log(`[BarRestaurantListFullscreen] Real-time - Pedido alterado:`, payload);
          
          // Atualizar lista local com novo status
          if (payload.eventType === 'INSERT') {
            if (payload.new.status_atual === listId) {
              setLocalOrders(prev => [payload.new, ...prev]);
            }
          } else if (payload.eventType === 'UPDATE') {
            if (payload.new.status_atual === listId) {
              setLocalOrders(prev => {
                const exists = prev.find(o => o.id === payload.new.id);
                if (exists) {
                  return prev.map(o => o.id === payload.new.id ? payload.new : o);
                }
                return [payload.new, ...prev];
              });
            } else {
              // Removeu da lista (mudou de status)
              setLocalOrders(prev => prev.filter(o => o.id !== payload.new.id));
            }
          } else if (payload.eventType === 'DELETE') {
            setLocalOrders(prev => prev.filter(o => o.id !== payload.old.id));
          }
        }
      )
      .subscribe();

    return () => {
      console.log(`[BarRestaurantListFullscreen] Desconectando Real-time`);
      supabase.removeChannel(ordersChannel);
    };
  }, [projectId, listId]);

  // ESC para fechar
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  const handleOpenOrder = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  return (
    <div className="fullscreen-overlay">
      <div className="fullscreen-container">
        {/* Header */}
        <div className="fullscreen-header">
          <div className="header-content">
            <h1>{listName}</h1>
            <span className="card-count">{localOrders.length} pedido{localOrders.length !== 1 ? 's' : ''}</span>
          </div>
          <button 
            className="btn-close-fullscreen" 
            onClick={onClose}
            title="Fechar (ESC)"
          >
            <AppIcon name="close" />
          </button>
        </div>

        {/* Grid de Cards */}
        <div className="fullscreen-grid">
          {localOrders.length === 0 ? (
            <div className="fullscreen-empty-state">
              <AppIcon name="receipt_long" />
              <p>Nenhum pedido em {listName.toLowerCase()}</p>
            </div>
          ) : (
            localOrders.map(order => (
              <div key={order.id} className="fullscreen-card-wrapper">
                <BarRestaurantOrderCard 
                  order={order} 
                  onOpenCard={handleOpenOrder}
                  isDragging={false}
                />
              </div>
            ))
          )}
        </div>
      </div>

      {/* Modal de Detalhes */}
      {showModal && selectedOrder && (
        <BarRestaurantOrderDetailModal
          order={selectedOrder}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}
